// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "about" + "-" + "b78816816ee2bca8113c" + ".css";
};